document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('contactModal');
  if (!modal) return;

  const panel = modal.querySelector('.form-wrapper');
  const closeBtn = modal.querySelector('button.close-modal');
  const openBtns = document.querySelectorAll('#openContactModal, .openContactModal, .openContactModalRight');

  let lastFocus = null;
  let trapHandler = null;

  function getFocusables() {
    return panel.querySelectorAll('a,button,input,textarea,select,[tabindex]:not([tabindex="-1"])');
  }

  function openModal() {
    lastFocus = document.activeElement;

    modal.classList.add('slide-right');
    modal.classList.add('show');
    document.documentElement.classList.add('overflow-hidden');

    requestAnimationFrame(() => {
      const f = getFocusables();
      if (f.length) f[0].focus();
    });

    trapHandler = trapFocus;
    document.addEventListener('keydown', trapHandler, true);
  }

  function closeModal() {
    modal.classList.remove('show');
    document.documentElement.classList.remove('overflow-hidden');

    if (trapHandler) {
      document.removeEventListener('keydown', trapHandler, true);
      trapHandler = null;
    }

    if (lastFocus) lastFocus.focus();
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !modal.classList.contains('show')) return;

    const f = getFocusables();
    if (!f.length) return;

    const first = f[0];
    const last = f[f.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  openBtns.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      openModal();
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', e => {
    if (e.target === modal) closeModal();
  });

  window.addEventListener('keydown', e => {
    if (e.key === 'Escape' && modal.classList.contains('show')) closeModal();
  });

  const params = new URLSearchParams(window.location.search);
  if (params.get('success') === '1') {
    openModal();
    const successEl = document.getElementById('formSuccess');
    if (successEl && window.innerWidth < 768) {
      successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
});
